var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDemoPanelBg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 593,
    height: 796,
    viewBox: "0 0 593 796",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.26803 6.26801 0 14 0H593V796H14C6.268 796 0 789.732 0 782V14Z",
    fill: "#F4F4FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M593 130C486.465 98.5581 487.704 30.2326 501.64 0H593V130Z",
    fill: "#E8E4FD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M535.71 453.646C559.43 467.633 583.787 494.441 593 506.097V609L0 228.358V99.4792C47.909 94.6504 169.055 93.5848 270.368 127.952C397.008 170.912 442.237 269.319 457.865 328.447C473.493 387.574 506.06 436.163 535.71 453.646Z",
    fill: "url(#paint0_linear_2830_3981)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M473.999 542.5C459.199 490.1 508.833 462.667 535.499 455.5H537.5C557.1 466.3 582 493.333 592 505.5V507.5V632.5C558.833 624.333 488.799 594.9 473.999 542.5Z",
    fill: "url(#paint1_linear_2830_3981)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M592.5 720C568.9 758.8 502.333 786.833 472 796H592.5V720Z",
    fill: "#E8E4FE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 486.016,
    cy: 640.016,
    r: 3.01638,
    fill: "#E5E0FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 486.016,
    cy: 667.164,
    r: 3.01638,
    fill: "#E5E0FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 486.016,
    cy: 695.819,
    r: 3.01638,
    fill: "#E5E0FF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 486.016,
    cy: 724.475,
    r: 3.01638,
    fill: "#E5E0FF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 507.05,
    cy: 640.016,
    r: 3.01638,
    fill: "#E5E0FF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 507.05,
    cy: 667.164,
    r: 3.01638,
    fill: "#E5E0FF"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 507.05,
    cy: 695.819,
    r: 3.01638,
    fill: "#E5E0FF"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 507.05,
    cy: 724.475,
    r: 3.01638,
    fill: "#E5E0FF"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 528.083,
    cy: 640.016,
    r: 3.01638,
    fill: "#E5E0FF"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 528.083,
    cy: 667.164,
    r: 3.01638,
    fill: "#E5E0FF"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 528.083,
    cy: 695.819,
    r: 3.01638,
    fill: "#E5E0FF"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 528.083,
    cy: 724.475,
    r: 3.01638,
    fill: "#E5E0FF"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 549.116,
    cy: 640.016,
    r: 3.01638,
    fill: "#E5E0FF"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 549.116,
    cy: 667.164,
    r: 3.01638,
    fill: "#E5E0FF"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 549.116,
    cy: 695.819,
    r: 3.01638,
    fill: "#E5E0FF"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 549.116,
    cy: 724.475,
    r: 3.01638,
    fill: "#E5E0FF"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 570.149,
    cy: 640.016,
    r: 3.01638,
    fill: "#E5E0FF"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 570.149,
    cy: 667.164,
    r: 3.01638,
    fill: "#E5E0FF"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 570.149,
    cy: 695.819,
    r: 3.01638,
    fill: "#E5E0FF"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 570.149,
    cy: 724.475,
    r: 3.01638,
    fill: "#E5E0FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2830_3981",
    x1: 449,
    y1: 307.5,
    x2: 403,
    y2: 347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4DFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2830_3981",
    x1: 531.649,
    y1: 455.5,
    x2: 531.649,
    y2: 632.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4FD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemoPanelBg);
export default __webpack_public_path__ + "static/media/demo-panel-bg.cb2df07a23ad41157088defa871b8317.svg";
export { ForwardRef as ReactComponent };